/** DEV defaults for RemoteConfig — game flags default to each game's shipped state, economy values from Multi_Game_Ecosystem.md §3.3/3.4/5.1. */
export const DEV_DEFAULTS = {
    blockjam_enabled: true,
    watersort_enabled: true,
    xp_enabled: true,
    // Module 96 — mirrors packages/remote-config's DEV_RC_DEFAULTS exactly; see
    // the reasoning there. Replaced the 5/10/20/40 tiers.
    reward_level_complete_base: 50,
    reward_level_complete_per_level: 1.5,
    daily_reward_day_1_coins: 100,
    daily_reward_day_1_gems: 0,
    daily_reward_day_2_coins: 120,
    daily_reward_day_2_gems: 0,
    daily_reward_day_3_coins: 150,
    daily_reward_day_3_gems: 1,
    daily_reward_day_4_coins: 150,
    daily_reward_day_4_gems: 0,
    daily_reward_day_5_coins: 200,
    daily_reward_day_5_gems: 2,
    daily_reward_day_6_coins: 200,
    daily_reward_day_6_gems: 0,
    daily_reward_day_7_coins: 300,
    daily_reward_day_7_gems: 3,
    // Module 22 (XP Bar & Profile) — mirrors packages/remote-config's DEV_RC_DEFAULTS exactly.
    xp_level_complete_easy: 80,
    xp_level_complete_medium: 160,
    xp_level_complete_hard: 300,
    xp_level_complete_expert: 500,
    xp_daily_reward_day_1: 20,
    xp_daily_reward_day_2: 25,
    xp_daily_reward_day_3: 30,
    xp_daily_reward_day_4: 30,
    xp_daily_reward_day_5: 40,
    xp_daily_reward_day_6: 40,
    xp_daily_reward_day_7: 60,
    xp_curve_base: 100,
    xp_curve_increment: 50,
    // Module 24 (Purchase Provider + RevenueCat) — mirrors packages/remote-config's
    // DEV_RC_DEFAULTS exactly.
    iap_enabled: true,
    iap_pack_small_coins: 5000,
    iap_pack_medium_coins: 25000,
    iap_pack_medium_gems: 10,
    iap_pack_large_coins: 60000,
    iap_pack_large_gems: 30,
    iap_rollout_percentage: 100,
    // Module 45 (WP-45.6) — mirrors packages/remote-config's DEV_RC_DEFAULTS exactly.
    // These two tables have been "kept in sync manually" since Module 02; as of
    // WP-45.6 a drift test asserts it instead, in the one package that depends on
    // both (apps/player-app/src/composition/startingGrant.test.ts).
    // Module 50 (WP-50.25) — 100 → 10, alongside the reward curve above.
    // Module 97 — 10 → 100 with the ×10 coin scale.
    starting_coins: 100,
};
